import { useState } from "react";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { imgSrc } from "@/lib/api";

export const PhotoGrid = ({ photos, testPrefix = "catalog" }) => {
  const [active, setActive] = useState(null);
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid={`${testPrefix}-grid`}>
        {photos.map((p, i) => (
          <motion.button
            key={p.id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.08 }}
            onClick={() => setActive(p)}
            className="group relative aspect-[4/3] rounded-3xl overflow-hidden bg-sand text-left"
            data-testid={`${testPrefix}-photo-${p.id}`}
          >
            <img src={imgSrc(p.src)} alt={p.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            <div className="absolute bottom-0 p-5">
              <p className="font-brand text-[10px] font-semibold tracking-[0.2em] uppercase text-white/80">{p.category}</p>
              <p className="mt-1 font-display text-2xl text-white">{p.title}</p>
            </div>
          </motion.button>
        ))}
      </div>
      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-5xl p-0 bg-noir border-none overflow-hidden [&>button]:hidden" data-testid="photo-lightbox">
          <DialogTitle className="sr-only">{active?.title}</DialogTitle>
          {active && (
            <div className="relative">
              <img src={imgSrc(active.src)} alt={active.title} className="w-full max-h-[80vh] object-contain" />
              <div className="p-5 text-white">
                <p className="font-brand text-[10px] tracking-[0.2em] uppercase text-white/60">{active.category}</p>
                <p className="font-display text-2xl">{active.title}</p>
              </div>
              <button onClick={() => setActive(null)} className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/90 grid place-items-center text-ink" data-testid="lightbox-close-btn" aria-label="Cerrar"><X className="w-5 h-5" /></button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
